module.exports = __webpack_public_path__ + "static/img/product01.c7a0f935.png";